import React from "react";
import { Trans } from "react-i18next";

export const INVOICE_TYPES = {
    1: <Trans>MANUAL</Trans>,
    2: <Trans>CREDIT_CARD</Trans>,
}
